import { render, staticRenderFns } from "./SmsOfferPresetDelivery.vue?vue&type=template&id=e0f41052&scoped=true&lang=pug&"
import script from "./SmsOfferPresetDelivery.vue?vue&type=script&lang=js&"
export * from "./SmsOfferPresetDelivery.vue?vue&type=script&lang=js&"
import style0 from "./SmsOfferPresetDelivery.vue?vue&type=style&index=0&id=e0f41052&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0f41052",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCard,VChip,VCol,VDivider,VForm,VRow,VTextField,VTextarea})
